import '../../scss/pool-size.scss'
import React, { Component } from 'react'
import gsap from 'gsap';
import {LiveMenuState} from './LiveRound'
import {liveMenuDescriptionHeight} from '../../utils/constants'

interface PoolSizeProps {
    poolValue: number
    isMobile:boolean
}

export default class PoolSize extends Component<PoolSizeProps>{

    mainDiv = React.createRef<HTMLDivElement>();
    originalBottomDistance = '5%'

    show = () => {
        gsap.to(this.mainDiv.current, {
            opacity: 1,
            duration: 0.5
        })
    }

    hide = () => {
        gsap.to(this.mainDiv.current, {
            opacity: 0,
            duration: 0.5
        })
    }

    lowerContent = (liveMenuState : LiveMenuState)=>{
        gsap.to(this.mainDiv.current, {
            bottom:liveMenuState === LiveMenuState.open ?  -liveMenuDescriptionHeight : this.originalBottomDistance,
            duration: 0.5
        })
    }

    render() {
        return (
            <div ref={this.mainDiv} className={this.props.isMobile ? "pool-size" : "pool-size-desktop" }>
                <p className="pool-size-content">{`$${this.props.poolValue} total pool size`}</p>
                <div className="pool-size-background"></div>
            </div>
        )
    }


}

